/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil';
// import XLSX from "xlsx";
import Swal from 'sweetalert2'

import iconavatar from '../images/icon-avatar.svg'
import moment from 'moment'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import SearchIcon from '@material-ui/icons/Search';


import axios from 'axios';
import InputGroup from 'react-bootstrap/InputGroup'
import { Col, Row, ListGroup, Container } from 'react-bootstrap';
import { Navbar, Nav, Form } from 'react-bootstrap'


import { Icon } from './Icon'
import CustomDateSelect from './CustomDateSelect'
// import Select from 'react-select';
// import { DateTime } from './share';

import { history } from '../router/route';
import { personState } from "../store"
import { authSign, requestBeacon } from '../service/role';

const BeaconLacationDetail = (props) => {
    const d = new Date();
    const startDate = new Date();
    const [location, setLocation] = useState({})
    const [logs, setLogs] = useState([])
    const [temps, setTemps] = useState([])
    const [zones, setZones] = useState([])
    const [searchTemp, setSearchTemp] = useState("")
    // const [beacons, setBeacons] = useState([])
    const [beaconsTemp, setBeaconsTemp] = useState([{ value: null, label: 'All' }])
    const [selectTemp, setSelectTemp] = useState({ value: null, label: 'All' })
    // const [beacon, setBeacon] = useState(null)
    const [dateRange, setDateRange] = useState([new Date(startDate.setDate(d.getDate() - 0)), d]);
    const user = useRecoilValue(personState)

    // const [excel_data, setExcelData] = useState([])


    // useEffect(() => {
    //   let isMounted = true; // note this mounted flag
    //   requestChartUsage();
    //   // convertData()
    //   return () => {
    //     isMounted = false;
    //   };

    // }, []);

    useEffect(() => {
        requestBeacons()
    }, [dateRange,searchTemp])

    
    async function requestBeaconLogs(rxid) {
        // var beforeDate = moment().add(-1, 'M');
        var finish = false
        var itemCount = 0
        var temp = []
        Swal.fire({
            html: 'กำลังโหลดข้อมูล <b></b>%',
            // timer: 2000,
            timerProgressBar: true,
            allowOutsideClick: false
        })
        Swal.isVisible()
        Swal.showLoading()
        do {
            const params = {
                "work": "BEACON_LOG.GET_BY_RXID",
                "item_per_request": 50000,
                "current_item_amount": itemCount,
                "rxid": rxid,
                "start": {
                    "date": parseInt(moment(dateRange[0]).format("DD")),
                    "month": parseInt(moment(dateRange[0]).format("MM")),
                    "year": parseInt(moment(dateRange[0]).format("YYYY")),
                    "hour": 0,
                    "minute": 0
                },
                "end": {
                    "date": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("DD") : new Date().getDay()),
                    "month": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("MM") : new Date().getMonth()),
                    "year": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("YYYY") : new Date().getFullYear()),
                    "hour": 23,
                    "minute": 59
                }
            }

            const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
                auth: {
                    username: process.env.REACT_APP_USERNAME,
                    password: process.env.REACT_APP_PASSWORD
                }
            });
            if (res.data.status === true) {
                if (res.data.result.length > 0) {
                    temp.push(...res.data.result)
                    itemCount += res.data.result.length
                } else {
                    finish = true
                }
            } else {
                finish = true
            }
        } while (!finish)
        setLogs(temp)
        setTemps(temp)
        Swal.close()
    }

    // async function requestLogs(value) {
    //     // var beforeDate = moment().add(-1, 'M');
    //     var finish = false
    //     var itemCount = 0
    //     var temp = []
    //     Swal.fire({
    //         html: 'กำลังโหลดข้อมูล <b></b>%',
    //         // timer: 2000,
    //         timerProgressBar: true,
    //         allowOutsideClick: false
    //     })
    //     Swal.isVisible()
    //     Swal.showLoading()
    //     do {
    //         const params = {
    //             "work": "BEACON_LOG.GET_BY_RXID",
    //             "item_per_request": 50000,
    //             "current_item_amount": itemCount,
    //             "rxid": selectTemp.value,
    //             "start": {
    //                 "date": parseInt(moment(value[0]).format("DD")),
    //                 "month": parseInt(moment(value[0]).format("MM")),
    //                 "year": parseInt(moment(value[0]).format("YYYY")),
    //                 "hour": 0,
    //                 "minute": 0
    //             },
    //             "end": {
    //                 "date": parseInt((value[1] !== null) ? moment(value[1]).format("DD") : new Date().getDay()),
    //                 "month": parseInt((value[1] !== null) ? moment(value[1]).format("MM") : new Date().getMonth()),
    //                 "year": parseInt((value[1] !== null) ? moment(value[1]).format("YYYY") : new Date().getFullYear()),
    //                 "hour": 23,
    //                 "minute": 59
    //             }
    //         }

    //         const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
    //             auth: {
    //                 username: process.env.REACT_APP_USERNAME,
    //                 password: process.env.REACT_APP_PASSWORD
    //             }
    //         });
    //         if (res.data.status === true) {
    //             if (res.data.result.length > 0) {
    //                 temp.push(...res.data.result)
    //                 itemCount += res.data.result.length
    //             } else {
    //                 finish = true
    //             }
    //         } else {
    //             finish = true
    //         }
    //     } while (!finish)
    //     setLogs(temp)
    //     setTemps(temp)
    //     Swal.close()
    // }


    // const time = (t)=>{
    //   if (t>60){
    //     return `${Math.floor(Math.floor(t)/60)} นาที ${Math.floor(t)%60} วินาที`
    //   }else{
    //     return `${Math.floor(t)} วินาที`
    //   }

    // }

    // const loadData = () => {
    //     let tempex = []
    //     logs.map((row, i) => {
    //         // if(i===0){
    //         //   tempex.push(["คลาสหน้าจอ","จำนวนครั้ง","จำนวนคน","เวลาเฉลี่ย"]);
    //         // }
    //         var obj = { "วัน": `${moment(row._cd).utc().format('DD/MM/YYYY')}`, "เวลา": `${moment(row._cd).utc().format('HH:mm:ss')}`, "beacon_id": `${row.beacon.minor_id}`, "ชื่อสถานที่": `${row.beacon.code_name}`, "รหัสพนักงาน": `${row.emp_id}`, "ชื่อ": `${row.person.first_name}`, "นามสกุล": `${row.person.last_name}`, "ละติจูด": `${row.location.latitude}`, "ลองติจูด": `${row.location.longitude}`, "ระยะ": `${row.meter}`, "รุ่นโทรศัพท์": row.device ? `${row.device ? row.device.brand : ''}, ${row.device ? row.device.model : ''}` : '-' }
    //         tempex.push(obj);
    //     })

    //     const ws = XLSX.utils.json_to_sheet(tempex);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, selectTemp.code_name);
    //     /* generate XLSX file and send to client */
    //     XLSX.writeFile(wb, `Beacon Log_${moment().format("DDMMYYYY-HH:mm:ss")}.xlsx`);
    // }

    const onSearchChange = (value) => {
        console.log(value.target.value.length)
       
        // this.toggleOpen();searchTemp
        if(value.target.value.length>4){
            setSearchTemp(value.target.value)
        }
        if(value.target.value.length===0){
            setSearchTemp(value.target.value) 
        }
        
    }

    // const onSelectChange = value => {
    //     // this.toggleOpen();
    //     setSelectTemp(value) || requestBeaconLogs(value.value)
    // }

    const onSelectDate = value => {
        // console.log(value)
        
        // setDateRange(value)
        if(value[1] === null){
            setDateRange(value)
        }else{
            setDateRange(value)
        }
        
        // if (value[1] !== null) {
        //     requestLogs(value)
        // }

    }
    function onClickToDetail(beacon_id, zone_id) {
        const location = {
            pathname: '/beacons-detail/'+ beacon_id,
            state: {
                "beacon_id": beacon_id,
                "zone_id": zone_id,
                "location_id": props.match.params.id,
            }
        }
        history.push(location)
    }
    // console.log(dateRange)
    async function requestBeacons() {
        const params = {
            "work": "LOCATION.GET_DETAILS_BY_ID",
            "search_value": searchTemp,
            "location_id": props.match.params.id,
            "start": {
                "date": parseInt(moment(dateRange[0]).format("DD")),
                "month": parseInt(moment(dateRange[0]).format("MM")),
                "year": parseInt(moment(dateRange[0]).format("YYYY")),
                "hour": 0,
                "minute": 0
            },
            "end": {
                "date": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("DD") : new Date().getDay()),
                "month": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("MM") : new Date().getMonth()),
                "year": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("YYYY") : new Date().getFullYear()),
                "hour": 23,
                "minute": 59
            }
        }
        // console.log(dateRange)
        const res = await authSign()
        if (res.data.status === true) {
            const result = await requestBeacon('location', params)
            if (result.data.status === true) {
                console.log(params)
                // console.log(result.data.result)
                setLocation(result.data.result.location)
                // setBeacons(res.data.result)
                var bTemps = []
                bTemps.push({ value: null, label: 'All' })
                setZones(result.data.result.zones)
                result.data.result.zones.forEach(element => {
                    bTemps.push({ value: element.rxid, label: element.code_name })
                });
                setBeaconsTemp(bTemps)
                if (selectTemp === null) {
                    setSelectTemp(bTemps(0))
                    requestBeaconLogs(bTemps(0).value)
                } else {
                    requestBeaconLogs(selectTemp.value)
                }

            }
        }
        // const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
        //     auth: {
        //         username: process.env.REACT_APP_USERNAME,
        //         password: process.env.REACT_APP_PASSWORD
        //     }
        // });
        // console.log(res)
        // if (res.data.status === true) {
        //     console.log(res.data)
        //     // setBeacons(res.data.result)
        //     var bTemps = []
        //     bTemps.push({ value: null, label: 'All' })
        //     res.data.result.forEach(element => {
        //         bTemps.push({ value: element.rxid, label: element.code_name })
        //     });
        //     setBeaconsTemp(bTemps)
        //     if (selectTemp === null) {
        //         setSelectTemp(bTemps(0))
        //         requestBeaconLogs(bTemps(0).value)
        //     } else {
        //         requestBeaconLogs(selectTemp.value)
        //     }

        // }
    }
    return (
        <>
            <Navbar bg="white" variant="white" className='border'>
                <Container>
                    <Nav.Link href="/" className="text-dark align-self-center">
                        <ChevronLeftIcon></ChevronLeftIcon> Back
                    </Nav.Link>
                    <Nav className="mr-auto" />
                    <Navbar.Text className="text-dark mx-1 clearfix">
                        {/* <CustomDateSelect onChange={date => setDateRangethis.setState({ scheduleDate: date }) || console.log(Number(utils.convertDateToTimeStamp(this.state.scheduleDate)))}></CustomDateSelect> */}
                        <CustomDateSelect onChange={onSelectDate} dateRange={dateRange}/>
                    </Navbar.Text>

                    <div className="media px-2">
                        <img src={iconavatar} alt={user ? user.profile ? user.profile.sub : '' : ''} className="align-self-center" />
                        <div className="media-body">
                            <p className="mb-0">{user ? user.profile ? user.profile.sub : '' : ''}</p>
                        </div>
                    </div>
                </Container>
            </Navbar>
            <Container>
                <Row>
                    <Col xs="3" md={3} sm={3} lg="2">
                        <div className="d-flex align-items-center py-2">
                            <Icon
                                className="mr-2 align-self-center text-green"
                                width={24}
                                height={24}
                                aria-hidden="true"
                                icon='BuildingIcon'
                            />
                            <div className="d-flex flex-column">
                                <h6 className='mb-0 text-uppercase'>{location.name}</h6>
                                <p className='mb-0'>{location.beacon ? location.beacon.amount : '0'} Beacones</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs="3" md={3} sm={3} lg="2">
                        <div className="d-flex flex-column py-2">
                            <p className='mb-0 text-muted text-uppercase'>All Records</p>
                            <h5 className='mb-0 font-weight-light'>{location.record ? location.record.amount : '0'}</h5>
                        </div>
                    </Col>
                    <Col xs="6" sm={6} md="6" lg="2">
                        <p className='text-break mb-0 py-2'>{location.address}</p></Col>
                    <Col xs="3" md={3} lg="2">
                        <div className="d-flex flex-column py-2">
                            <label className='mb-0 text-muted text-bolder'>ละติจูด</label>
                            <h6 className='mb-0 font-weight-light'>{location.latitude}</h6>
                        </div>
                    </Col>
                    <Col xs="3" md={3} lg="2">
                        <div className="d-flex flex-column py-2">
                            <label className='mb-0 text-muted text-bolder'>ลองติจูด</label>
                            <h6 className='mb-0 font-weight-light'>{location.longitude}</h6>
                        </div>
                    </Col>
                    <Col xs="6" md={6} lg="2">
                        <Form.Group className='mb-0 py-2'>
                            <InputGroup.Prepend className='position-absolute'>
                                <InputGroup.Text id="basic-addon1" className="bg-white border-0 bg-transparent mt-1">
                                    <SearchIcon></SearchIcon>
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder="ค้นหา" style={{ paddingLeft: '2.5rem' }} onChange={onSearchChange} />
                        </Form.Group>
                    </Col>
                </Row>
            </Container>
            <div className="border-top"></div>
            <ListGroup>
                {
                    zones.map((zone, index) => {
                        return <ListGroup.Item variant="flush" className="border-top-0" key={index}>
                            <Container>
                                <Row>
                                    <Col className="px-0">
                                        <div className='d-flex justify-content-start'>
                                            <div className="d-flex align-items-center py-2">
                                                <Icon
                                                    className="mr-2 align-self-center"
                                                    width={24}
                                                    height={24}
                                                    aria-hidden="true"
                                                    icon='BuildingIcon'
                                                />
                                                <div className="d-flex flex-column">
                                                    <h6 className='mb-0 text-uppercase'>{zone.name}</h6>
                                                    <p className='mb-0'>{zone.beacon ? zone.beacon.amount : '0'} Beacones</p>
                                                </div>
                                            </div>

                                        </div>

                                    </Col>

                                    <Col className="px-1">
                                        <div className="d-flex flex-column py-2">
                                            <p className='mb-0 text-muted text-uppercase'>Records</p>
                                            <p className='mb-0 font-weight-light'>{zone.record ? zone.record.amount : '0'}</p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="justify-content-start">

                                    {/* <div className="d-flex justify-content-center"> */}
                                    {
                                        zone.beacon ? zone.beacon.list.map((beacon, bindex) => {
                                            return (
                                                <Col xs={3} className="px-0" key={bindex}>
                                                    <div className="d-flex align-items-center p-2" onClick={() => onClickToDetail(beacon._id, zone._id)} style={{ 'cursor': 'pointer' }}>
                                                        <Icon
                                                            className="mr-2 align-self-center"
                                                            width={32}
                                                            height={32}
                                                            aria-hidden="true"
                                                            icon='BeaconIcon'
                                                            style={{ "color": "#027840" }}
                                                        />
                                                        <div className="d-flex flex-column">
                                                            <h6 className='mb-0'>{`${beacon.minor_id ? beacon.minor_id + ' - ' : ''}${beacon.name}`}</h6>
                                                            <p className='mb-0'>พบข้อมูล {beacon.amount} รายการ</p>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )

                                        }) : ''
                                    }
                                    {/* </div> */}

                                </Row>
                            </Container>
                        </ListGroup.Item>
                    })
                }
            </ListGroup>
            {/* </Card> */}
        </>
    )

}

export default BeaconLacationDetail